var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3476 31.1169L17.5236 14.1441L22.158 12.9009L38.8404 28.3089L51.4692 24.9249C52.3915 24.6779 53.3741 24.8074 54.2009 25.285C55.0277 25.7625 55.631 26.549 55.878 27.4713C56.1249 28.3936 55.9954 29.3762 55.5178 30.2031C55.0403 31.0299 54.2539 31.6331 53.3316 31.8801L17.3988 41.5041L15.5364 34.5489L16.1147 34.3929L22.0356 40.2609L15.7332 41.9505C15.2163 42.089 14.6681 42.0509 14.1754 41.8422C13.6827 41.6335 13.2739 41.2661 13.014 40.7985L6.71875 29.4561L10.1964 28.5249L16.1147 34.3929L28.3476 31.1145V31.1169ZM12.8004 48.8001H51.2004V53.6001H12.8004V48.8001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightIcon);
export default __webpack_public_path__ + "static/media/flight-icon.1c388b31c6bc0476feae8a269f4e19af.svg";
export { ForwardRef as ReactComponent };